import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/components/AuthProvider';
import { getUserPermissions } from '@/integrations/supabase/permissions';

export function usePermission(module: string, action: string) {
  const { user, empresa, isOwner } = useAuth();
  const empresaId = empresa?.id;

  // Proprietários têm acesso total a tudo
  if (isOwner) {
    return true;
  }

  const { data: permissions = {} } = useQuery({
    queryKey: ['permissions', user?.id, empresaId],
    queryFn: () => (user && empresaId ? getUserPermissions(user.id, empresaId) : Promise.resolve({})),
    enabled: !!user && !!empresaId,
    staleTime: 5 * 60 * 1000 // 5 minutos
  });

  const modulePermissions = permissions[module] || {};
  return modulePermissions[action] === true;
}

export function useModulePermissions(module: string) {
  const { user, empresa, isOwner } = useAuth();
  const empresaId = empresa?.id;

  // Proprietários têm acesso total a tudo
  if (isOwner) {
    return { read: true, create: true, update: true, delete: true };
  }

  const { data: permissions = {} } = useQuery({
    queryKey: ['permissions', user?.id, empresaId],
    queryFn: () => (user && empresaId ? getUserPermissions(user.id, empresaId) : Promise.resolve({})),
    enabled: !!user && !!empresaId,
    staleTime: 5 * 60 * 1000
  });

  return permissions[module] || {};
}

export function useAllPermissions() {
  const { user, empresa } = useAuth();
  const empresaId = empresa?.id;

  const { data: permissions = {} } = useQuery({
    queryKey: ['permissions', user?.id, empresaId],
    queryFn: () => (user && empresaId ? getUserPermissions(user.id, empresaId) : Promise.resolve({})),
    enabled: !!user && !!empresaId,
    staleTime: 5 * 60 * 1000
  });

  return permissions;
}
